function visionariesTicker() {
	const blocks = document.querySelectorAll(".visionaries-ticker");

	blocks.forEach((block) => {
		const carousel = block.querySelector(".embla");
		const wrapper = block.querySelector(".embla__container");
		const slides = wrapper
			? Array.from(wrapper.querySelectorAll(".embla__slide"))
			: [];
		const prev = block.querySelector(".visionaries-ticker__control--prev");
		const next = block.querySelector(".visionaries-ticker__control--next");

		const minSlides = Math.max(slides.length * 3, 10);

		while (wrapper.children.length < minSlides) {
			slides.forEach((slide) => {
				const clone = slide.cloneNode(true);
				clone.setAttribute("aria-hidden", "true");
				wrapper.appendChild(clone);
			});
		}

	const autoScroll = EmblaCarouselAutoScroll({
    speed: 0.75,
    startDelay: 0,
    playOnInit: false,
    stopOnMouseEnter: false,
    stopOnInteraction: true,
  });

		const embla = EmblaCarousel(
			carousel,
			{
				loop: true,

				align: "center",
				breakpoints: {
					"(min-width: 768px)": { align: "start" },
				},
				containScroll: false,
			},
			[autoScroll],
		);

		const revealPrev = () => {
			block.classList.add("visionaries-ticker--has-moved");
		};

		let userHasInteracted = false;
		let tickerHasStarted = false;
		let startTimer = false;

		const startTicker = () => {
			if (userHasInteracted || tickerHasStarted || startTimer) {
				return;
			}

			startTimer = window.setTimeout(() => {
				startTimer = false;

				if (userHasInteracted) {
					return;
				}

				tickerHasStarted = true;
				autoScroll.play();
			}, 1000);
		};

		const pauseTicker = () => {
			if (!userHasInteracted) {
				autoScroll.stop();
			}
		};

		const resumeTicker = () => {
			if (!userHasInteracted && tickerHasStarted) {
				autoScroll.play();
			}
		};

		const stopTicker = () => {
			autoScroll.stop();
			userHasInteracted = true;
			revealPrev();
		};

		if (prev) {
			prev.addEventListener("click", () => {
				stopTicker();
				embla.scrollPrev();
			});
		}

		if (next) {
			next.addEventListener("click", () => {
				stopTicker();
				embla.scrollNext();
			});
		}

		carousel.addEventListener("mouseenter", pauseTicker);
		carousel.addEventListener("mouseleave", resumeTicker);

		embla.on("pointerDown", stopTicker);
		embla.on("scroll", revealPrev);

		if ("IntersectionObserver" in window) {
			const observer = new IntersectionObserver(
				(entries) => {
					if (entries[0].isIntersecting) {
						startTicker();
						observer.unobserve(carousel);
					}
				},
				{ threshold: 0.1 },
			);

			observer.observe(carousel);
		} else {
			startTicker();
		}
	});
}

visionariesTicker();
